import { useDispatch } from "react-redux";
import { uiActions, visualizerActions } from "../../store";

import FacebookShareLink from "../FacebookShareLink/FacebookShareLink";
import XShareLink from "../XShareLink/XShareLink";
import PintrestShareLink from "../PintrestShareLink/PintrestShareLink";
import { EmailShareLink } from "../EmailShareModal/EmailShareModal";
import PopUpModal from "../PopUpModal/PopUpModal";

import { generateShareLink } from "../../Helpers/ShareHelper";

import styles from "./ShareModal.module.css";


export default function ShareModal() {

    const dispatch = useDispatch();

    const handleClose = function () {
        dispatch(uiActions.setShareModalActive(false));
    }

    // Update share data
    generateShareLink().then(result => {
        dispatch(visualizerActions.setShareData(result));
    })

    return (
        <>
            <PopUpModal handleClose={handleClose}>
                <div className={styles.contentMain}>
                    <h2>Share Your Project</h2>
                    <div className={styles.flexRow}>
                        <FacebookShareLink />
                        <XShareLink />
                        <PintrestShareLink />
                        <EmailShareLink />
                    </div>
                </div>
            </PopUpModal>
        </>
    );
}
